// extracted by mini-css-extract-plugin
module.exports = {"bottom":"bottom-Bei9SGgS"};